var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Top floating menu component.
 * Used to show menu when clicked on wallet (after connecting)
 * to show additional menu items like "copy address", "open in etherscan", and "disconnect"
 *
 * ONLY visible on desktop
 */
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import sizes from "../../designSystem/sizes";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var Container = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"], ["\n  ", "\n\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
    return props.isOpen
        ? "\n         position: absolute;\n         right: 0px;\n         top: 64px;\n         width: fit-content;\n         background-color: " + colors.background.two + ";\n         border-radius: " + theme.border.radius + ";\n       "
        : "\n         display: none;\n       ";
}, sizes.md);
var DesktopFloatingMenu = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, containerStyle = _a.containerStyle, _b = _a.transition, transition = _b === void 0 ? {
        moveY: 20,
    } : _b;
    return (_jsx(AnimatePresence, { children: _jsx(Container, __assign({ isOpen: isOpen, style: containerStyle, initial: {
                opacity: 0,
                y: transition.moveY,
            }, animate: {
                opacity: 1,
                y: 0,
            }, exit: {
                opacity: 0,
                y: transition.moveY,
            }, transition: {
                type: "keyframes",
                duration: 0.2,
            } }, { children: children }), isOpen.toString()) }, void 0));
};
export default DesktopFloatingMenu;
var templateObject_1;
//# sourceMappingURL=DesktopFloatingMenu.js.map